import {SOPostExportProject} from '../../core/export-project/so-post-export-project';
import {ExportProjectCore} from './export-project.core';
import {SOGetExportProject} from '../../core/export-project/so-get-export-project';
import {FormField, SelectionOption} from 'lionheartland';
import {postExportProjectFormFieldOptions} from './post-export-project-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostExportProject extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postExportProjectFormFieldOptions);

  RequestClass = SOPostExportProject

  constructor(
    public entityCore: ExportProjectCore
  ) {
    super();
    if (postExportProjectFormFieldOptions.project) {
      postExportProjectFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('reasonForExport'),
      this.getFormValueFromIdentifier('exportType'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}